module.exports = __webpack_public_path__ + "static/media/token9.a0bfdceb.png";